import React, { ReactNode } from "react";

import styles from "./matter-auto-complete-dropdown.module.css";

const { ["container"]: containerClassName } = styles as any;

export const MatterAutoCompleteDropdown: React.FC<{ children?: ReactNode }> = ({ children }) => {
  return (
    <div className={containerClassName}>
      <div>{children}</div>
    </div>
  );
};
